var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3473 30.5882L8.70755 26.0728L3.46273 24.9961L4.0532 19.8902L0.71875 16L4.0532 12.1445L3.46273 7.03864L8.70755 5.96188L11.3473 1.41174L16.0017 3.56525L20.656 1.41174L23.3305 5.96188L28.5406 7.03864L27.9501 12.1445L31.2846 16L27.9501 19.8902L28.5406 24.9961L23.3305 26.0728L20.656 30.5882L16.0017 28.4347L11.3473 30.5882ZM12.2851 27.8442L16.0017 26.2812L19.8224 27.8442L22.1496 24.3709L26.2134 23.3288L25.7966 19.1955L28.6101 16L25.7966 12.735L26.2134 8.60166L22.1496 7.62911L19.7529 4.15572L16.0017 5.71875L12.1809 4.15572L9.85376 7.62911L5.7899 8.60166L6.20671 12.735L3.39326 16L6.20671 19.1955L5.7899 23.3983L9.85376 24.3709L12.2851 27.8442ZM14.5081 20.6196L22.3927 12.8045L20.8297 11.3804L14.5081 17.6325L11.2084 14.1938L9.61063 15.7568L14.5081 20.6196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bf365698ee9b0b02e0671045c2699a76.svg";
export { ForwardRef as ReactComponent };